import Page from "../models/page";

function initQuizSession() {
  if (Page.controller !== "quiz_sessions") return;

  let topics;

  const initOrUpdateChosen = function (init = true) {
    const $topic = $("#topic");
    const $subject = $("#subject option:selected");

    console.log("subject", $subject);

    if (init) {
      topics = $topic.html();
    }

    if ($subject) {
      let options = "";
      const name = $subject.data("name");
      options += `<optgroup label="${name}">\n`;
      options += $(topics).filter(`optgroup[label="${name}"]`).html() + "\n";
      options += "</optgroup>\n";

      $topic.html(options);
    } else {
      $topic.html(topics);
    }

    if (init) {
      $(".chosen-select").chosen();
    }

    $topic.trigger("chosen:updated");
  };

  initOrUpdateChosen();

  $(document).on("change", "#subject", function () {
    initOrUpdateChosen(false);
  });

  $(document).on("quiz_sessions:new", function () {
    initOrUpdateChosen();
  });

  $(document).on("click", ".complaint-button", function () {
    const value = this.getAttribute("data-complaint");
    $("#quiz_item_id").val(value);
  });

  $(document).on(
    "change",
    '#quiz-taker .quiz-item-choices input[type="radio"]',
    function () {
      const session = this.closest("form").getAttribute("data-session");
      const question = this.getAttribute("name").replace("question", "");
      const answer = this.value;

      $.ajax({
        method: "PUT",
        url: "/api/v1/quiz_sessions/" + session + "/answer",
        dataType: "json",
        data: { question: question, answer: answer },
      });
    }
  );
}

export default initQuizSession;
